// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__mqjSd","content":"styles_content__9PbfQ"};